var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container"},[_c('img',{staticClass:"image",attrs:{"src":_vm.diagram,"alt":"Safe Diagram"}}),_c('div',{staticClass:"mac-address"},[_vm._v("\n      "+_vm._s(_vm.macAddress.toUpperCase())+"\n    ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }